import { render, staticRenderFns } from "./notificationItem.vue?vue&type=template&id=346f3424"
import script from "./notificationItem.vue?vue&type=script&lang=js"
export * from "./notificationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports